import {
  Group,
  Geometry,
  Vector3,
  TorusBufferGeometry,
  SphereBufferGeometry,
  MeshBasicMaterial,
  Mesh,
  Face3,
} from "three"

const createTriangle = () => {
  var geometry = new Geometry()

  geometry.vertices.push(new Vector3(-0.1, -0.06, 0))
  geometry.vertices.push(new Vector3(0.1, -0.06, 0))
  geometry.vertices.push(new Vector3(0, 0.1, 0))

  geometry.faces.push(new Face3(0, 1, 2))
  geometry.computeFaceNormals()

  geometry.scale(0.5, 0.5, 1)
  geometry.rotateX(-Math.PI / 2)
  geometry.rotateY(Math.PI / 2.2)

  return geometry
}

const createSphere = radius => {
  const geometry = new SphereBufferGeometry(radius, 32, 32)

  geometry.scale(1, 0.1, 1)

  return geometry
}

const createMarker = (lat, lon, threeProps, type) => {
  const markerGroup = new Group()
  const outsideCircleGeometry = new TorusBufferGeometry(0.1, 0.005, 32, 64)
  const geometry =
    type === "triangle"
      ? createTriangle()
      : createSphere(threeProps.marker[type].radius)
  const maskGeometry = new SphereBufferGeometry(0.2, 32, 32)
  const material = new MeshBasicMaterial(threeProps.marker[type].material)
  const maskMaterial = new MeshBasicMaterial({
    visible: false,
  })
  const pin = new Mesh(geometry, material)
  const outsideCircle = new Mesh(outsideCircleGeometry, material)
  const mask = new Mesh(maskGeometry, maskMaterial)

  const latRad = lat * (Math.PI / 180)
  const lonRad = -lon * (Math.PI / 180)
  const r = threeProps.globe.radius

  outsideCircle.rotation.set(Math.PI / 2, 0, 0)

  markerGroup.position.set(
    Math.cos(latRad) * Math.cos(lonRad) * r,
    Math.sin(latRad) * r,
    Math.cos(latRad) * Math.sin(lonRad) * r
  )
  markerGroup.rotation.set(0.0, -lonRad, latRad - Math.PI * 0.5)
  markerGroup.scale.set(1.5, 1, 1.5)

  markerGroup.add(pin, outsideCircle, mask)

  return {
    object: markerGroup,
    outside: outsideCircle,
    inside: pin,
  }
}

export default createMarker
